import React from "react";
import T from "prop-types";
import styles from "MODULES/parts/components/Detail/styles";
import Form from "./Form";

SendRfqNestedForm.propTypes = {
  close: T.func.isRequired,
  lineItem: T.shape({})
};

export default function SendRfqNestedForm({ close, lineItem }) {
  return (
    <div className="panel panel-default" style={styles.container}>
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Request for Repair Quote
        </h4>
        <Form close={close} lineItem={lineItem} modal={false} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/Send/SendRfqNestedForm.jsx